/* 🤖 this file was generated by svg-to-ts */
export const matIconLocalHospital: {
  name: 'local-hospital';
  data: string;
} = {
  name: 'local-hospital',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z"/></svg>`
};
